import React, { useState } from 'react';
import axiosInstance from './axiosInstance';
import { getApiErrorMessage } from '../utils/apiError';

const ForgotPasswordForm = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    try {
      const response = await axiosInstance.post('password_reset/', { email });
      setMessage(response.data.message);
    } catch (error) {
      setError(getApiErrorMessage(error, 'Password reset request failed. Please try again.'));
      console.error('Password reset error:', error);
    }
  };

  return (
    <div>
      <h2>Password Reset</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button type="submit">Reset Password</button>
      </form>
      {message && <p>{message}</p>}
      {error && <p className="whitespace-pre-line">{error}</p>}
    </div>
  );
};

export default ForgotPasswordForm;
